import { Dispatch } from 'redux';

import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';

import { addClientFlashMessage } from '../flash-messages/redux';

export const registerListener = ({ dispatch }: { dispatch: Dispatch }) => {
    const showMessage = (message: FlashMessage) => {
        dispatch(addClientFlashMessage(message));
    };

    if (typeof window.flashmessages === 'undefined') {
        window.flashmessages = [];
    }

    const flashmessages = window.flashmessages as FlashMessage[];

    flashmessages.forEach(showMessage);

    const oldPush = flashmessages.push;

    flashmessages.push = (...items: any[]) => {
        items.forEach(showMessage);

        return oldPush.apply(flashmessages, items);
    };
};
